import { useState } from "react";
import { Plus } from "lucide-react";
import api from "@/api";
import { toast } from "sonner";

export const LabValueForm = ({ patientId, markers, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ marker: "hemoglobin", value: "", unit: "", sampleDate: new Date().toISOString().slice(0, 10) });
  const [saving, setSaving] = useState(false);
  const selected = markers.find((m) => m.key === form.marker);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post(`/patients/${patientId}/lab-values`, { ...form, value: parseFloat(String(form.value).replace(",", ".")), unit: form.unit || selected?.unit });
      toast.success("Valeur biologique ajoutée");
      setForm((f) => ({ ...f, value: "" }));
      setOpen(false);
      onSaved?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossible d'ajouter la valeur");
    } finally {
      setSaving(false);
    }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} data-testid="lab-add-value-btn" className="inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700 border border-emerald-200 bg-emerald-50 rounded-lg px-3 py-1.5 hover:bg-emerald-100">
        <Plus className="w-4 h-4" /> Saisir une valeur
      </button>
    );
  }
  return (
    <form onSubmit={submit} data-testid="lab-add-value-form" className="flex flex-wrap items-end gap-2 bg-slate-50 border border-slate-200 rounded-xl p-3">
      <label className="text-xs text-slate-600">Marqueur
        <select value={form.marker} onChange={(e) => setForm({ ...form, marker: e.target.value, unit: "" })} data-testid="lab-form-marker" className="block mt-1 border rounded-lg px-2 py-1.5 text-sm bg-white">
          {markers.map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
        </select>
      </label>
      <label className="text-xs text-slate-600">Valeur
        <input required type="text" inputMode="decimal" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} data-testid="lab-form-value" className="block mt-1 border rounded-lg px-2 py-1.5 text-sm w-24" />
      </label>
      <label className="text-xs text-slate-600">Unité
        <input type="text" placeholder={selected?.unit} value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })} data-testid="lab-form-unit" className="block mt-1 border rounded-lg px-2 py-1.5 text-sm w-24" />
      </label>
      <label className="text-xs text-slate-600">Date prélèvement
        <input required type="date" value={form.sampleDate} onChange={(e) => setForm({ ...form, sampleDate: e.target.value })} data-testid="lab-form-date" className="block mt-1 border rounded-lg px-2 py-1.5 text-sm" />
      </label>
      <button type="submit" disabled={saving} data-testid="lab-form-submit" className="bg-emerald-600 text-white text-sm font-semibold rounded-lg px-3 py-1.5 hover:bg-emerald-700 disabled:opacity-50">{saving ? "…" : "Enregistrer"}</button>
      <button type="button" onClick={() => setOpen(false)} data-testid="lab-form-cancel" className="text-sm text-slate-500 px-2 py-1.5">Annuler</button>
    </form>
  );
};

export default LabValueForm;
